import React, { Component } from 'react';

import { Button, Form, FormControl, FormGroup, FormText } from 'react-bootstrap';
import { Link } from "react-router-dom";

import { Formik } from 'formik';
import { accountRegistrationFormSchema } from "./validation-rules";

import '../../styles/app-styles.scss';

class AccountRegistrationForm extends Component {
  onFormSubmit = (values, { setSubmitting }) => {
    this.props.registrationSubmittedCallback(values, setSubmitting);
  };

  render() {
    return (
      <div className="p-5 form-container" id="view-register-local-account">
        <div className="text-center">
          <h1 className="h4 text-gray-900 mb-4">Δημιούργησε ένα λογαριασμό!</h1>
        </div>

        <Formik onSubmit={this.onFormSubmit}
                validationSchema={accountRegistrationFormSchema}
                initialValues={{}}>
          {( {values, errors, touched,
               handleChange, handleBlur, handleSubmit,
               isSubmitting }) => (
            <Form className="user" noValidate onSubmit={handleSubmit}>
              <FormGroup className="row">
                <div className="col-sm-6 mb-3 mb-sm-0">
                  <FormControl type="text" name="firstName" id="firstName"
                               className="form-control-user"
                               value={values.firstName || ''}
                               onChange={handleChange}
                               onBlur={handleBlur}
                               isInvalid={touched.firstName && errors.firstName}
                               placeholder="Όνομα" autoFocus/>
                </div>
                <div className="col-sm-6">
                  <FormControl type="text" name="lastName" id="lastName"
                               className="form-control-user"
                               value={values.lastName || ''}
                               onChange={handleChange}
                               onBlur={handleBlur}
                               isInvalid={touched.lastName && errors.lastName}
                               placeholder="Επίθετο" required/>
                </div>
              </FormGroup>
              <FormGroup>
                <FormControl type="email" name="email" id="email"
                             className="form-control-user"
                             value={values.email || ''}
                             onChange={handleChange}
                             onBlur={handleBlur}
                             isInvalid={touched.email && errors.email}
                             placeholder="Διεύθυνση Email" required/>
                <FormText className="text-center text-muted">Δε μοιραζόμαστε το email σου με κανέναν άλλο!</FormText>
              </FormGroup>
              <FormGroup className="row">
                <div className="col-sm-6 mb-3 mb-sm-0">
                  <FormControl type="password" name="password" id="password"
                               className="form-control-user"
                               value={values.password || ''}
                               onChange={handleChange}
                               onBlur={handleBlur}
                               isInvalid={touched.password && errors.password}
                               placeholder="Κωδικός" required/>
                </div>
                <div className="col-sm-6">
                  <FormControl type="password" name="password2" id="password2"
                               className="form-control-user"
                               value={values.password2 || ''}
                               onChange={handleChange}
                               onBlur={handleBlur}
                               isInvalid={touched.password2 && errors.password2}
                               placeholder="Επανάληψη Κωδικού"/>
                </div>
                {
                  touched.password && errors.password &&
                  <div className="col-sm-6">
                    <FormText className="field-error">{errors.password}</FormText>
                  </div>
                }
              </FormGroup>
              {
                this.props.error &&
                <div className="text-center action-error" id="view-register-local-account-action-error">
                  {this.props.error}
                </div>
              }
              <Button variant="primary" type="submit" id="form-submit" className="btn-user" block disabled={isSubmitting}>Δημιούργησε λογαριασμό</Button>
            </Form>
          )}
        </Formik>

        <hr/>
        <div className="text-center">
          <Link to="/login" className="small">Είσοδος σε υπάρχων λογαριασμό</Link>
        </div>
      </div>
    );
  }
}

export default AccountRegistrationForm;